import { useEffect, useState } from "react";
import { CollectionMetafields } from "~/types";
import { collectionList } from "../../../setup/settings/index";
type PropsHeaderCollection = {
  collection: CollectionMetafields
}

export default function HeaderCollection({ collection }: PropsHeaderCollection) {

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (collection.landscape?.value) {
      setUrl(collection.landscape?.value);
    }
  }, [url])

  return (
    <>
      {collectionList && collectionList.contactUrl ?
        <section className="headerCollectioListCustom">
          <img src={url}></img>
        </section> :
        <section className="ProductTop" >
          <div className="ProductTop_container ">
            <div className="ProductTop__img">
              <img className="Product-img" src={url}></img>
            </div>
          </div>
        </section>
      }
    </>
  )
}